module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAGUExURf///wcnhGCdMKcAAAAJcEhZcwAADsIAAA7CARUoSoAAAAAySURBVCjPY6ATEEQBWAXggjAOhgB25WhaILbhFCDWDFRBVAHCfiFGAOY5HAKDATAwAAAODAzBSFlJSQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/images/ico-dex.png
// module id = 206
// module chunks = 0